// Dev tools network data model and helpers.
// Each entry composes a measurment or networktraffic (resource/ajax) structure.

import { PageModel } from './Page';

export interface NetworkRsp {
  data: NetworkTraffic[];
  performanceMetrics: UserTiming[];
  ajaxWatchWasEnabled: boolean;
  ajaxShimWhen: number;
}

export interface Header {
  name: string;
  value: string | null;
}

interface Request {
  method: string;
  url: string;
  httpVersion: string; // Missing
  type: InitiatorType;
  headers: Header[];
  queryString: Query[];
  postData: PostData;
  headersSize: number; // -1 if not available
  bodySize: number; // -1 if not available
}

interface Query {
  name: string;
  value: string;
}

interface PostData {
  mimeType: string;
  params: string[];
  text?: string;
  comment: string;
}

interface Response {
  status: number;
  statusText: string;
  httpVersion: string;
  headers: Header[];
  content: Content;
  redirectURL: string;
  headersSize: number;
  bodySize: number;
}

interface Content {
  size: number;
  compression: number;
  mimeType: string;
  encoding: string;
  text?: string;
}

interface NetworkSource {
  resource: boolean;
  xhrResource: boolean;
  navigation: boolean;
  ajax: boolean;
}

export interface Timing {
  dns: number;
  connect: number;
  send: number;
  wait: number;
  receive: number;
  ssl: number;
  blocked: number;
}

export enum InitiatorType {
  css = 'css',
  embed = 'embed',
  fetch = 'fetch',
  img = 'img',
  link = 'link',
  object = 'object',
  other = 'other',
  script = 'script',
  subdocument = 'subdocument',
  svg = 'svg',
  xmlhttprequest = 'xmlhttprequest',
  mobile = 'mobile',
}
// Keep synchronized with networkzipper.go

// NetworkTraffic is composed of AJAX requests, resource performance timings.
export interface NetworkTraffic {
  startTime: string;
  duration: number;
  request: Request;
  response: Response;
  timings: Timing;
  source: NetworkSource;
}

// User Timing Performance API
export interface UserTiming {
  startTime: string;
  name: string;
  duration: number;
  type: 'measurement' | 'mark';
}

export type NetworkEntry = NetworkTraffic | UserTiming;

export interface NetworkItem<T extends NetworkEntry> {
  id: string;
  When: number;
  entry: T;
  page: PageModel;
  idx: number;
  pageIdx: number;
  /** @deprecated  */
  detailIdx: number;

  // View properties.
  hidden: boolean;
  ajaxWatchWasEnabled: boolean;
  pendingShim: boolean;
}

export function isNetworkData(o: NetworkEntry): o is NetworkTraffic {
  return (<NetworkTraffic>o).source !== undefined;
}

export function hasNetworkData(o: NetworkItem<NetworkEntry>): o is NetworkItem<NetworkTraffic> {
  return (<NetworkTraffic>o.entry).source !== undefined;
}

export function isUserTiming(o: NetworkEntry): o is UserTiming {
  return !isNetworkData(o);
}

export function hasUserTiming(o: NetworkItem<NetworkEntry>): o is NetworkItem<UserTiming> {
  return !hasNetworkData(o);
}
